import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { UploadSaleReceiptForm } from "./uploadSaleReceiptForm"
import { TableName } from "../../../../../tables"
import { SalePaymentItem, SaleOperation } from "../../../state/types"

type Props = {
    table: TableName
    operation?: SaleOperation
    paymentItem?: SalePaymentItem
}

export const UploadSaleReceiptFormModal = (props: Props) => {
    const { table, operation, paymentItem } = props
    
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.UPLOAD_SALE_RECEIPT}
            title="Subir Comprobante de Pago"
            widthSize="m"
            actions={[]}
        >
            <UploadSaleReceiptForm
                key={key}
                table={table}
                operation={operation}
                paymentItem={paymentItem}
            />
        </Modal>
    )
}
